import { render, staticRenderFns } from "./ItemEditPopup.vue?vue&type=template&id=b2f74b74&scoped=true&"
import script from "./ItemEditPopup.vue?vue&type=script&lang=js&"
export * from "./ItemEditPopup.vue?vue&type=script&lang=js&"
import style0 from "./ItemEditPopup.vue?vue&type=style&index=0&id=b2f74b74&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2f74b74",
  null
  
)

export default component.exports